module.exports = __webpack_public_path__ + "static/media/landing-tablet-2x.7b77fbea.jpg";